// ─────────────────────────────────────────────────────────────────
// Glass-i — Investments grid columns (Stage 6B.9E).
//
// Columns: # / Code / Name / Category / Institution / Investment Date /
//          Maturity Date / Principal / Current Value / Accrued Income /
//          Status / Actions
// ─────────────────────────────────────────────────────────────────

import { Tag } from 'antd';
import { formatINR } from '../../../../components/common/erp-grid';
import { STATUS_COLOR, STATUS_LABEL } from './investmentsHelpers';

function fmtDate(v) {
  return v ? String(v).slice(0, 10) : <span className="erp-grid__muted">—</span>;
}

export function buildInvestmentsColumns({ currentPage, pageSize } = {}) {
  return [
    { title: '#', key: '__sno__', width: 56, align: 'center', fixed: 'left',
      render: (_v, _r, idx) => {
        const cp = Number(currentPage) > 0 ? Number(currentPage) : 1;
        const ps = Number(pageSize)    > 0 ? Number(pageSize)    : 25;
        return (cp - 1) * ps + idx + 1;
      } },
    { title: 'Code', dataIndex: 'investmentCode', key: 'investmentCode',
      width: 160, sorter: true, filter: true,
      render: (v) => (v ? <code className="erp-grid__code">{v}</code> : <span className="erp-grid__muted">—</span>) },
    { title: 'Name', dataIndex: 'investmentName', key: 'investmentName',
      sorter: true, filter: true,
      render: (v) => v || <span className="erp-grid__muted">—</span> },
    { title: 'Category', dataIndex: 'categoryName', key: 'categoryName',
      width: 160, filter: true,
      render: (v) => v || <span className="erp-grid__muted">—</span> },
    { title: 'Institution', dataIndex: 'institutionName', key: 'institutionName',
      width: 160, filter: true,
      render: (v) => v || <span className="erp-grid__muted">—</span> },
    { title: 'Investment Date', dataIndex: 'investmentDate', key: 'investmentDate',
      width: 130, sorter: true, render: fmtDate },
    { title: 'Maturity Date', dataIndex: 'maturityDate', key: 'maturityDate',
      width: 130, sorter: true, render: fmtDate },
    { title: 'Principal', dataIndex: 'principalAmount', key: 'principalAmount',
      width: 130, sorter: true, align: 'right',
      render: (v) => `₹ ${formatINR(Number(v) || 0)}` },
    { title: 'Current Value', dataIndex: 'currentValue', key: 'currentValue',
      width: 130, sorter: true, align: 'right',
      render: (v) => `₹ ${formatINR(Number(v) || 0)}` },
    { title: 'Accrued Income', dataIndex: 'accruedIncome', key: 'accruedIncome',
      width: 130, sorter: true, align: 'right',
      render: (v) => `₹ ${formatINR(Number(v) || 0)}` },
    { title: 'Status', dataIndex: 'status', key: 'status', width: 110,
      filter: true, sorter: true,
      render: (v) => v
        ? <Tag color={STATUS_COLOR[v] || 'default'}>{STATUS_LABEL[v] || v}</Tag>
        : <span className="erp-grid__muted">—</span> }
  ];
}
